import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the DirectionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-directions',
  templateUrl: 'directions.html',
})
export class DirectionsPage {
  showMap = false;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DirectionsPage');
  }

  showMapFn(){
    console.log(this.showMap);
    if(this.showMap){
      this.showMap = false;
    }else{
      this.showMap = true;
    }
  }

  goback(){
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/directions/directions.ts